import "./index.scss";

import React from "react";

class ConfirmCreation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { title, body, onClose, onConfirm } = this.props
        return (
            <div class="modal fade bg-overlay add-modal account-confirmation-modal show in" data-backdrop="static" data-keyboard="false" id="accountConfirmationModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bb">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="modalTitle">{title}</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a  class="text-right text-black" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body">
                            { body }
                        </div>
                        <div class="modal-footer">
                            <div class="modalActions">
                                <button type="button" class={`btn btn-secondary btn-cancel`} data-dismiss="modal" onClick={onClose}>Cancel</button>
                                <button type="button" class={`btn btn-create`} onClick={onConfirm}>Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmCreation;
